'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var React__default = _interopDefault(React);
var layoutTree = require('./layoutTree.js');
var uuid = require('uuid');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// NOTE: Used for exhaustive matching.
var emptyRender = function emptyRender(_nodeType, key) {
  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: key
  });
};
var renderLayout = function renderLayout(options) {
  if (!options) return /*#__PURE__*/React.createElement(React.Fragment, null);
  var node = options.node,
    view = options.view,
    row = options.row,
    col = options.col,
    stack = options.stack,
    feature = options.feature;
  var key = node && node.id || uuid.v4();
  if (node.type === layoutTree.TreeNodeTypes.FEATURE) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, feature({
      node: Object.freeze(_objectSpread(_objectSpread({}, node), {}, {
        children: null
      }))
    }));
  }
  if (node.type === layoutTree.TreeNodeTypes.STACK) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, stack({
      node: Object.freeze(_objectSpread(_objectSpread({}, node), {}, {
        children: null
      })),
      children: node.children,
      feature: feature
    }));
  }
  var childrenMapCallback = function childrenMapCallback(child) {
    return renderLayout({
      node: child,
      view: view,
      row: row,
      col: col,
      stack: stack,
      feature: feature
    });
  };
  if (node.type === layoutTree.TreeNodeTypes.VIEW) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, view({
      node: Object.freeze(_objectSpread(_objectSpread({}, node), {}, {
        children: null
      })),
      children: node.children.map(childrenMapCallback)
    }));
  }
  if (node.type === layoutTree.TreeNodeTypes.ROW) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, row({
      node: Object.freeze(_objectSpread(_objectSpread({}, node), {}, {
        children: null
      })),
      children: node.children.map(childrenMapCallback)
    }));
  }
  if (node.type === layoutTree.TreeNodeTypes.COL) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, col({
      node: Object.freeze(_objectSpread(_objectSpread({}, node), {}, {
        children: null
      })),
      children: node.children.map(childrenMapCallback)
    }));
  }

  // NOTE: Exhaustive matching.
  var type = node.type;
  return emptyRender(type, key);
};

exports.default = renderLayout;
